import Globals from './Globals.js';
import rpAPI from '../service/rpAPI.js';

class Instructor {
  static fields = [
    
    'id',
    'title',
    'first_name',
    'last_name',
    'avatar',
    'description'

  ];


  constructor(data) {
    this.id = data.id;
    this.title = data.title;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.avatar = data.avatar;
    this.description = data.description || '';
    this.fullName = `${this.first_name} ${this.last_name}`;

    if (this.avatar) {
      this.image = rpAPI.getAssetUrl(`${this.avatar}.webp`, '?width=120&quality=80&format=webp');
    }
    else {
      this.image = null;
    }
  }
}

export default Instructor;
